import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useHistory} from 'react-router-dom';
import styled from 'styled-components';

import {loadPlans} from 'actions/accountActions';

import {getLocalUser} from 'constants/selectors';

import AppPageHeader from 'components/common/AppPageHeader';
import PageRow from 'components/common/PageRow';
import CardSection from './components/CardSection';
import CardModal from './components/card_modal/CardModal';
import PlansSection from './components/plans_section/PlansSection';

const PageContainer = styled.div`
  width: ${props => (props.editMode ? '100%' : '118.8rem')};
`;

function SubscribePage() {
  const dispatch = useDispatch();
  let history = useHistory();

  const cardDetails = {};
  const [cardModalVisible, setCardModalVisible] = useState(false);
  const [plans, setPlans] = useState({});
  const user = useSelector(getLocalUser);

  if (user && user.subscription_id !== null && user.subscription_id !== '') {
    console.log(`${user.email} is already subscribed`);
    history.push('/');
  }

  useEffect(() => {
    initData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function initData() {
    let initialPlans: any = await dispatch(loadPlans());

    setPlans(initialPlans);
  }

  function toggleCardModalVisibility() {
    setCardModalVisible(!cardModalVisible);
  }

  function render() {
    return (
      <PageContainer editMode={cardModalVisible}>
        {cardModalVisible ? (
          <CardModal cardDetails={cardDetails} goBack={toggleCardModalVisibility} />
        ) : (
          <>
            <AppPageHeader title="We have the perfect plan for you" />

            <PageRow>
              <PlansSection plans={plans} />

              <div>
                <CardSection />
              </div>
            </PageRow>
          </>
        )}
      </PageContainer>
    );
  }

  return render();
}

export default SubscribePage;
